import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import King from "../../images/KG_B.png";
import Rook from "../../images/RK_B.png";
import Bishop from "../../images/BP_B.png";
import Queen from "../../images/QN_B.png";
import Knight from "../../images/KT_B.png";
import Pawn from "../../images/PN_B.png";

import "./rules.css";
const Watch = () => {
	const history = useHistory();

	return (
		<div className="rules-page101">
			<div className="rules-container">
				<div className="rule-section-gameplay">
					<h1 className="section-title">GAMEPLAY</h1>
					<p className="description">
						The player controlling the white pieces is named "White"; the player controlling the black pieces is named "Black".
						White moves first, then players alternate moves. Making a move is required; it is not legal to skip a move, even when
						having to move is detrimental. Play continues until a king is checkmated, a player resigns, or a draw is declared, as
						explained below. In addition, if the game is being played under a time control players who exceed their time limit
						lose the game.
					</p>
				</div>

				<div className="rule-section-movement">
					<h1 className="section-title">MOVEMENT</h1>
					<div className="sub-section">
						<img src={King} alt="King" />
						<h5>KING</h5>
						<p className="description">
							The king moves exactly one square horizontally, vertically, or diagonally. A special move with the king known as
							castling is allowed only once per player.
						</p>
					</div>

					<div>
						<img src={Rook} alt="Rook" />
						<h5>ROOK</h5>
						<p className="description">
							{" "}
							A rook moves any number of vacant squares horizontally or vertically. It also is moved when castling.
						</p>
					</div>

					<div>
						<img src={Bishop} alt="Bishop" />
						<h5>BISHOP</h5>
						<p className="description">A bishop moves any number of vacant squares diagonally.</p>
					</div>

					<div>
						<img src={Queen} alt="Queen" />
						<h5>QUEEN</h5>
						<p className="description"> The queen moves any number of vacant squares horizontally, vertically, or diagonally.</p>
					</div>

					<div>
						<img src={Knight} alt="Knight" />
						<h5>KNIGHT</h5>
						<p className="description">
							A knight moves to the nearest square not on the same rank, file, or diagonal. This can be thought of as moving two
							squares horizontally then one square vertically, or moving one square horizontally then two squares vertically The
							knight is not blocked by other pieces: it jumps to the new location.
						</p>
					</div>

					<div>
						<img src={Pawn} alt="Pawn" />
						<h5>PAWN</h5>
						<p className="description">
							A pawn moves straight forward one square, if that square is vacant. If it has not yet moved, a pawn also has the
							option of moving two squares straight forward, provided both squares are vacant. Pawns cannot move backwards. Pawns
							are the only pieces that capture differently from how they move. A pawn can capture an enemy piece on either of the
							two squares diagonally in front of the pawn.
						</p>
					</div>

					<div>
						<h5>CASTLING</h5>
						<p className="description">
							Castling consists of moving the king two squares towards a rook, then placing the rook on the other side of the
							king, adjacent to it. Castling is only permissible if all of the following conditions hold: [1] The king and rook
							involved in castling must not have previously moved, [2] There must be no pieces between the king and the rook, [3]
							The king may not currently be in check, nor may the king pass through or end up in a square that is under attack by
							an enemy piece (though the rook is permitted to be under attack and to pass over an attacked square), [4] The
							castling must be kingside or queenside as shown in the diagram.
						</p>
					</div>

					<div>
						<h5>EN PASSANT</h5>
						<p className="description">
							When a pawn advances two squares from its original square and ends the turn adjacent to a pawn of the opponent's on
							the same rank, it may be captured by that pawn of the opponent's, as if it had moved only one square forward. This
							capture is only legal on the opponent's next move immediately following the first pawn's advance.
						</p>
					</div>

					<div>
						<h5>PAWN PROMOTION</h5>
						<p className="description">
							If a player advances a pawn to its eighth rank, the pawn is then promoted (converted) to a queen, rook, bishop, or
							knight of the same color at the choice of the player (a queen is usually chosen).
						</p>
					</div>
				</div>

				<div className="rule-section-endOfGame">
					<h1 className="section-title">END OF THE GAME</h1>
					<h5>CHECKMATE</h5>
					<p className="description">
						If a player's king is placed in check and there is no legal move that player can make to escape check, then the king
						is said to be checkmated, the game ends, and that player loses.
					</p>

					<h5>RESIGNING</h5>
					<p className="description">Either player may resign at any time, conceding the game to their opponent.</p>

					<h5>DEAD POSITION</h5>
					<p className="description">
						A dead position is defined as a position where neither player can win the game by any sequence of legal moves.
					</p>

					<h5>DRAW</h5>
					<p className="description">
						The game is drawn if one of the following conditions is met: [1] The game is automatically a draw if the player to
						move is not in check and has no legal move. This situation is called a stalemate. An example of such a position is
						shown in the adjacent diagram, [2] The game is immediately drawn for a dead position, [3] Both players agree to a draw
						after one of the players makes such an offer, [4] When the same board position has occurred five times.
					</p>

					<h5>FLAG-FALL</h5>
					<p className="description">
						A game played under time control will end as a loss for a player who uses up all of their allotted time, which is
						called Flag-fall.
					</p>
				</div>
				<button className="back" onClick={() => history.push("/")}>
					BACK
				</button>
			</div>
		</div>
	);
};

export default Watch;
